import styled from 'styled-components'

export const FiltersContainer = styled.div`
  background-color: white;
  padding: ${props => props.theme.spacing.sp8};
  padding-left: ${props => props.theme.spacing.sp16};
  border-radius: ${props => props.theme.primitives.radius.radius6};
  display: flex;
  gap: ${props => props.theme.spacing.sp40};
  box-shadow: 0px 5px 16px 0px rgba(0, 60, 70, 0.12);
`

export const FiltersSubContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
  align-items: center;
  justify-content: center;
`
